import { render, staticRenderFns } from "./toBeReceive.vue?vue&type=template&id=fdb9e42a&"
import script from "./toBeReceive.js?vue&type=script&lang=js&"
export * from "./toBeReceive.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports